import React, { useEffect, useState } from 'react';
import { FaTwitter } from 'react-icons/fa';
import { RejectListLayout, RejectListBody, RejectListRow, RejectListRowKu,
    RejectListRowOfHead, ButtonContainer } from './RejectList.style.js';
import { GREEN } from '../../styles/color';
import FW from '../../config/word.json';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/Layouts/Main/MainLayout.index.js';
import { GreenSmallButton, LoadingSpinner, LoadingOverlay, colorButtonStyle } from '../../styles/common.js';
import { getAllProInfoByAuthFlg, updateUserFromApproval } from "../../api/project";
import Modal from 'react-modal';
import * as XLSX from 'xlsx'; // Excel出力用ライブラリ
import {
    SmallButtonForDetail,
} from '../../styles/common.js';

function RejectList(props) {

    const threespace = '　　　';
    const navigate = useNavigate();

    const [tasks, setTasks] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [currentTask, setCurrentTask] = useState({});
    const [reloadEffect, setReloadEffect] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedUserFlg, setSelectedUserFlg] = useState({});

    // フィルター用
    const [filterTwitterName, setFilterTwitterName] = useState('');
    const [filterEmail, setFilterEmail] = useState('');
    const [filterUserFlg, setFilterUserFlg] = useState('');

    const handleDetailClick = (item) => {
        navigate(`/register?userId=${item.user_id}`); // 適切なIDやパラメータを渡す
    };
    
    useEffect(() => {
        const userId = sessionStorage.getItem('userId');
        if (!userId) {
            navigate('/');
            return;
        }

        getAllProInfoByAuthFlg('3').then(res => {
            setTasks(res.data);
        });
    }, [reloadEffect, navigate]);


    const updateTask = async (task) => {
        const jUser = {
            userId: task.user_id,
            email: task.email,
            userName: task.user_name,
            userFlg: selectedUserFlg[task.user_id],
            authFlg: '1',
        };

        await updateUserFromApproval(jUser).then(res => {
            if (res.code === 200) {
                navigate('/RejectList');
            }
        });

        await new Promise(resolve => setTimeout(resolve, 1000));
    };

    const openModal = (task) => {
        setCurrentTask(task);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const resetState = () => {
        setCurrentTask({});
        setReloadEffect(prev => !prev);
    };

    const handleApprove = async () => {
        closeModal();
        setLoading(true);
        await updateTask(currentTask);
        setLoading(false);
        resetState();
    };

    const handleGenderChange = (proId, value) => {
        setSelectedUserFlg(prevUserFlg => ({
            ...prevUserFlg,
            [proId]: value
        }));
    };

    // 🔍 フィルター後の配列
    const filteredTasks = tasks.filter(item => {
        const matchUserFlg = filterUserFlg === '' || item.user_flg === filterUserFlg;
        const matchTwitter = filterTwitterName === '' || (item.twitter_name || '').toLowerCase().includes(filterTwitterName.toLowerCase());
        const matchEmail = filterEmail === '' || (item.email || '').toLowerCase().includes(filterEmail.toLowerCase());
        return matchUserFlg && matchTwitter && matchEmail;
    });

    const handleExportToExcel = () => {
        const data = filteredTasks.map(task => ({
            'Twitter名': task.twitter_name,
            'Twitter ID': task.user_id,
            '表示名': task.user_name,
            'メールアドレス': task.email,
            'ユーザ種別': selectedUserFlg[task.user_id] || '未選択',
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'RejectList');
        XLSX.writeFile(wb, 'RejectList.xlsx');
    };

    const TwitterIcon = () => <FaTwitter />;

    return (
        <MainLayout>
            <RejectListLayout>
                <RejectListBody>
                    <div style={{ marginBottom: '10px', textAlign: 'left', color: '#888787'}}>
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                        {FW.F_W_HOME_RejectList}
                        </span>
                    </div>
                    {/* 絞り込み条件 */}
                    <div style={{ marginBottom: '10px', textAlign: 'left', color: '#666', fontStyle: 'italic' }}>
                        <span style={{ fontSize: '13px', fontWeight: 'normal' }}>
                            絞り込み条件
                        </span>
                    </div>

                    {/* 🔍 フィルターUI */}
                    <div style={{ marginBottom: '20px', display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div>
                            <label>種別：</label>
                            <select value={filterUserFlg} onChange={(e) => setFilterUserFlg(e.target.value)}>
                                <option value=''>すべて</option>
                                <option value='1'>プロ</option>
                                <option value='2'>ゲスト</option>
                                <option value='3'>雀荘</option>
                                <option value='4'>麻雀BAR</option>
                            </select>
                        </div>
                        <div>
                            <label><TwitterIcon />：</label>
                            <input
                                type="text"
                                value={filterTwitterName}
                                onChange={(e) => setFilterTwitterName(e.target.value)}
                                placeholder="例: 麻雀太郎"
                            />
                        </div>
                        <div>
                            <label>E-Mail：</label>
                            <input
                                type="text"
                                value={filterEmail}
                                onChange={(e) => setFilterEmail(e.target.value)}
                                placeholder="例: example@mail.com"
                            />
                        </div>
                        <div>
                            <button onClick={() => {
                                setFilterUserFlg('');
                                setFilterTwitterName('');
                                setFilterEmail('');
                            }}>クリア</button>
                        </div>
                        <div>
                            {/* Excel出力ボタン */}
                            <button onClick={handleExportToExcel}>Excel出力</button>
                        </div>
                    </div>

                    {/* 承認済一覧の件数表示 */}
                    <div style={{ marginBottom: '10px', textAlign: 'left', color: '#666', fontStyle: 'italic' }}>
                        <span style={{ fontSize: '13px', fontWeight: 'normal' }}>
                            否認済一覧    📊 全データ：{tasks.length} 件 ／ フィルター結果：{filteredTasks.length} 件
                        </span>
                    </div>

                    {/* ヘッダ */}
                    <RejectListRowOfHead>Twitter名前／ID</RejectListRowOfHead>
                    <RejectListRowOfHead>{threespace}雀活マスター表示名前</RejectListRowOfHead>
                    <RejectListRowOfHead>{threespace}{threespace}E-Mail</RejectListRowOfHead>
                    <RejectListRowOfHead>{threespace}プロ／ゲスト{threespace}{threespace}処理</RejectListRowOfHead>

                    {loading && (
                        <LoadingOverlay>
                            <LoadingSpinner />
                        </LoadingOverlay>
                    )}

                    {filteredTasks.map((item) => (
                        <RejectListBody key={item.user_id}>
                            <RejectListRow>
                                <TwitterIcon />{item.twitter_name}／
                                <a href={`https://x.com/${item.user_id}`} target="_blank" rel="noopener noreferrer">{item.user_id}</a>
                            </RejectListRow>
                            <RejectListRow>{threespace}{item.user_name}</RejectListRow>
                            <RejectListRow>{threespace}{threespace}{item.email}</RejectListRow>
                            <RejectListRow>
                                <input type="radio" name={`userFlg_${item.user_id}`} value="1"
                                    checked={selectedUserFlg[item.user_id] === '1'}
                                    onChange={(e) => handleGenderChange(item.user_id, e.target.value)} />プロ
                                <input type="radio" name={`userFlg_${item.user_id}`} value="2"
                                    checked={selectedUserFlg[item.user_id] === '2'}
                                    onChange={(e) => handleGenderChange(item.user_id, e.target.value)} />ゲスト
                                <input type="radio" name={`userFlg_${item.user_id}`} value="3"
                                    checked={selectedUserFlg[item.user_id] === '3'}
                                    onChange={(e) => handleGenderChange(item.user_id, e.target.value)} />雀荘
                                <input type="radio" name={`userFlg_${item.user_id}`} value="4"
                                    checked={selectedUserFlg[item.user_id] === '4'}
                                    onChange={(e) => handleGenderChange(item.user_id, e.target.value)} />麻雀BAR
                                <GreenSmallButton onClick={() => openModal(item)}>復活</GreenSmallButton>
                                <SmallButtonForDetail onClick={() => handleDetailClick(item)}>詳細</SmallButtonForDetail>
                            </RejectListRow>
                            <RejectListRowKu />
                        </RejectListBody>
                    ))}
                </RejectListBody>
            </RejectListLayout>

            <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel="雀活マスター承認">
                <div>
                    <p>◾️申込者：<br />
                        ・{currentTask.twitter_name}<br />
                        ・{currentTask.user_name}<br />
                        ・{currentTask.email}<br />
                        ・{
                            selectedUserFlg[currentTask.user_id] === "1" ? "プロ" :
                                selectedUserFlg[currentTask.user_id] === "2" ? "ゲスト" :
                                    selectedUserFlg[currentTask.user_id] === "3" ? "雀荘" :
                                        selectedUserFlg[currentTask.user_id] === "4" ? "麻雀BAR" : ""
                        }
                        <br /><br />雀活マスターアプリの利用権限を付与します
                    </p>
                </div>
                <ButtonContainer>
                    <button onClick={closeModal}>いいえ</button>
                    <button style={colorButtonStyle(GREEN)} onClick={handleApprove}>復活</button>
                </ButtonContainer>
            </Modal>
        </MainLayout>
    );
}

export default RejectList;
